import { render } from "./wsDemo.vue?vue&type=template&id=3fc833d6&scoped=true"
import script from "./wsDemo.vue?vue&type=script&lang=js"
export * from "./wsDemo.vue?vue&type=script&lang=js"

import "./wsDemo.vue?vue&type=style&index=0&id=3fc833d6&scoped=true&lang=css"

import exportComponent from "D:\\work\\jyzs\\jyzs-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc833d6"]])

export default __exports__